import { html } from "lit";
import type {
  CodexUsage,
  CodexUsageAggregate,
  UsageField,
} from "../api/client";
import { i18n } from "../i18n";

export const usageFields: UsageField[] = [
  "input",
  "output",
  "cached",
  "cache_write",
  "total",
];
export const usageLabels = {
  input: "usageInput",
  output: "usageOutput",
  cached: "usageCached",
  cache_write: "usageCacheWrite",
  total: "usageTotal",
} as const;
export function usageValue(usage: CodexUsage | undefined, field: UsageField) {
  const value = usage?.source === "total" ? usage[field] : null;
  return typeof value === "number" && Number.isFinite(value) && value >= 0
    ? value
    : null;
}
export function formatUsage(value: number | null | undefined) {
  return typeof value === "number" && Number.isFinite(value) && value >= 0
    ? new Intl.NumberFormat(i18n.language).format(value)
    : i18n.t("usageUnavailable");
}
export function formatDuration(value: number | null | undefined) {
  return typeof value === "number" && Number.isFinite(value) && value >= 0
    ? `${new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 2 }).format(value / 1000)} s`
    : i18n.t("usageUnavailable");
}
export function renderUsage(usage: CodexUsage | undefined) {
  return html`<div class="codex-usage-summary">
    ${usageFields.map(
      (field) =>
        html`<div>
          <span>${i18n.t(usageLabels[field])}</span>
          <strong>${formatUsage(usageValue(usage, field))}</strong>
        </div>`,
    )}
    ${
      usage?.source === "total" && usage.reasoning_output != null
        ? html`<div>
            <span>${i18n.t("usageReasoning")}</span>
            <strong>${formatUsage(usage.reasoning_output)}</strong>
          </div>`
        : null
    }
    <p>${i18n.t("usageNote")}</p>
  </div>`;
}

export function cacheRate(
  total: number | null | undefined,
  cached: number | null | undefined,
): number | null {
  if (
    total == null ||
    cached == null ||
    !Number.isFinite(total) ||
    !Number.isFinite(cached) ||
    total <= 0 ||
    cached < 0
  )
    return null;
  return (cached / total) * 100;
}
export function inputCacheRate(value: CodexUsageAggregate): number | null {
  return cacheRate(value.tokens.input, value.tokens.cached);
}
